import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

export const schedulesRegisterSlice = createSlice({
  name: 'schedulesRegister',
  initialState: { schedulesRegister: initialState },
  reducers: {
    schedulesRegisterApi: (state, data) => {
      state.schedulesRegister = data.payload;
    },
  },
});

export const { schedulesRegisterApi } = schedulesRegisterSlice.actions;

export default schedulesRegisterSlice.reducer;
